import axios from "axios";
import { API_URL } from "../../config/config";
import API from "../../common/API";

/*** 
  @purpose : Get territory definition list
  @Parameter : {}
  **/
  export const getTerritoryAllocationList = async (body) => {
    const token = sessionStorage.getItem("token");
    let timestamp = new Date().getTime()
    return await axios.get(API_URL + API.GET_TERRITORY_ALLOCATION_LIST + `?territorySetID=${body.territoryID}&salesOfficeID=${body.salesOfficeID}&currentMonth=${body.currentMonth}&limit=${body.limit}&totalRecords=${body.totalRecords}&timestamp=${timestamp}`,
    { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "timestamp": timestamp}}
    )
      .then((response) => {
        if (response.data.success == true) {
          return response.data;
        }
      });
  };

  /*** 
  @purpose : Get employee list
  @Parameter : {}
  **/
  export const fetchEmployeeList = async (body) => {
    const token = sessionStorage.getItem("token");
    let timestamp = new Date().getTime()
    return await axios.get(API_URL + API.GET_EMPLOYEE_LIST + `?territorySetID=${body.territoryID}&salesOfficeID=${body.salesOfficeID}&currentMonth=${body.currentMonth}&timestamp=${timestamp}`,
    { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "timestamp": timestamp}}
    )
      .then((response) => {
        if (response.data.success == true && response.data.data) {
          return response.data.data;
        }
      });
  };

  /*** 
  @purpose : Search employee
  @Parameter : {}
  **/
  export const searchEmployee = async (body) => {
    const token = sessionStorage.getItem("token");
    let timestamp = new Date().getTime()
    return await axios.get(API_URL + API.GET_EMPLOYEE_LIST + `?salesOfficeID=${body.salesOfficeID}&search=${body.searchText}&timestamp=${timestamp}`,
    { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "timestamp": timestamp, mode: 'no-cors'}}
    )
      .then((response) => {
        if (response.data.success == true && response.data.data) {
          return response.data.data;
        }
      });
  };

  export const saveTerritoryAllocation = async (body) => {
    const token = sessionStorage.getItem("token");
    let timestamp = new Date().getTime()
    const wwid = sessionStorage.getItem("WWID");
    return fetch(API_URL + API.SAVE_TERRITORY_ALLOCATION, {
      method: "post",
      headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', 'wwid': wwid, "timestamp": timestamp, mode: 'no-cors'},
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        return data;
      });
  };